import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, InputNumber, notification} from 'antd';

import {getPurchaseOrder, updatePurchaseOrderProduct} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdatePurchaseOrderProductForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.purchaseId !== this.props.match.params.purchaseId) {
      this._load();
    }
  }

  _load = () => {
    const {purchaseId} = decodeParams(this.props.match.params);
    if (purchaseId) {
      this.props.getPurchaseOrder({purchaseId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {purchaseId, productId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updatePurchaseOrderProduct({...values, purchaseId, productId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, purchaseOrder} = this.props;
    const products = (purchaseOrder && purchaseOrder.items) || [];
    const {productId} = decodeParams(this.props.match.params);
    const product = products.find(({productId: pid}) => (pid === productId)) || {};
    const {productDisplay, quantity, netCostPerUnit} = product;
    return (
      <Card title="Update Purchase Order Product">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Purchase Order"
          >
            {`${purchaseOrder.supplierName} - ${purchaseOrder.status} (${purchaseOrder.modifiedAt})`}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Product"
          >
            {productDisplay}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Quantity"
          >
            {getFieldDecorator('quantity', {
              initialValue: quantity,
              rules: [
                { required: true, message: 'Please input your Quantity' },
              ]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Net Cost Per Unit"
          >
            {getFieldDecorator('netCostPerUnit', {
              initialValue: netCostPerUnit,
              rules: [
              ]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Purchase Order Product
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdatePurchaseOrderProductForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  updatePurchaseOrderProduct: PropTypes.func.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
};

const UpdatePurchaseOrderProductPage = Form.create()(UpdatePurchaseOrderProductForm);

const mapStateToProps = state => ({
  loading: state.purchaseOrder.purchaseOrderLoading || state.purchaseOrder.updatePurchaseOrderProductLoading,
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
});

const mapDispatchToProps = dispatch => ({
  updatePurchaseOrderProduct: payload => (dispatch(updatePurchaseOrderProduct(payload))),
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdatePurchaseOrderProductPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/UpdatePurchaseOrderProductPage.js